import React, { useEffect, useCallback } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Lightbox = ({ images, index, onClose, onNavigate }) => {
  const goPrev = useCallback(
    () => onNavigate((index - 1 + images.length) % images.length),
    [index, images.length, onNavigate]
  );
  const goNext = useCallback(
    () => onNavigate((index + 1) % images.length),
    [index, images.length, onNavigate]
  );

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') goPrev();
      if (e.key === 'ArrowRight') goNext();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [goPrev, goNext, onClose]);

  const image = images[index];
  if (!image) return null;

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox-close" onClick={onClose} aria-label="Close">
        <X size={20} />
      </button>
      <button
        className="lightbox-nav prev"
        onClick={(e) => { e.stopPropagation(); goPrev(); }}
        aria-label="Previous image"
      >
        <ChevronLeft size={22} />
      </button>
      <div className="lightbox-image-wrap" onClick={(e) => e.stopPropagation()}>
        <img src={image.url} alt={image.title} />
        <div className="lightbox-caption">
          <span className="folio">
            {String(index + 1).padStart(2, '0')} / {String(images.length).padStart(2, '0')}
          </span>
          <div className="display-3" style={{ color: 'var(--text-dark-1)', marginTop: '0.5rem' }}>
            {image.title}
          </div>
        </div>
      </div>
      <button
        className="lightbox-nav next"
        onClick={(e) => { e.stopPropagation(); goNext(); }}
        aria-label="Next image"
      >
        <ChevronRight size={22} />
      </button>
    </div>
  );
};

export default Lightbox;
